import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME, DEFAULT_SLUG } from '../../layouts/menuData.js';

export default function StatusPage({ code, title, message, icon, action }) {
  return (
    <div className="d-flex flex-column min-vh-100">
      <header className="navbar bg-primary">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <i className="fas fa-bolt me-2" aria-hidden="true" />
            {APP_NAME}
          </Link>
        </div>
      </header>
      <main className="container d-flex flex-grow-1 align-items-center justify-content-center py-5">
        <div className="card text-center p-5" style={{ maxWidth: 520, width: '100%' }}>
          <div className="display-1 fw-bold text-primary">
            <i className={`${icon} me-2`} aria-hidden="true" />
            {code}
          </div>
          <h1 className="h3 mt-3">{title}</h1>
          <p className="text-muted">{message}</p>
          <div className="d-flex gap-2 justify-content-center">
            {action}
            <Link className="btn btn-outline-primary" to={`/${DEFAULT_SLUG}`}>
              Back to {APP_NAME}
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
